import { deepEqual } from './deepEqual';
import { deepMerge } from './deepMerge';

/**
 * Helps to simplify React.Component state updating.
 * Merges current component state with partial update,
 * checks if rerender needed,
 * verifies that callback is function.
 *
 * @param {Object} partial - The partial update of the component state
 * @param {Function} setState - The component setState function, should be bonded to the component
 * @param {Function} callback - Optional. The setState callback function
 */
export const updateState = async (partial, setState, callback) => {
  await setState(
    state => {
      const newState = deepMerge(state, partial);

      if (deepEqual(state, newState)) {
        return null;
      }

      return newState;
    },
    typeof callback === 'function' ? callback : undefined,
  );
};

export const stateReducer = (state, newState) => {
  if (typeof newState === 'function') {
    const result = newState(state);
    if (typeof result !== 'object' || result === null) {
      return state;
    }
    return result;
  }
  return { ...state, ...newState };
};
